export const Capitalize = (text: string): string => {
  if (typeof text !== 'string') return '';
  return text.toLowerCase().replace(/\w/, (firstLetter) => firstLetter.toUpperCase());
};

export const toTitleCase = (phrase: string) => {
  return phrase.toLowerCase().split(' ').map(Capitalize).join(' ');
};
